// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"a04bb139","67":"d70fff6b","380":"ec44c9d3","452":"75f40d03","481":"12e6634a","682":"6fa5e74b","816":"9f147ab3","928":"e1de3a80","978":"fb089373"}[chunkId] + ".chunk.css";
};